export default __webpack_public_path__ + "static/reeves-county-0a980041020f445fb8d38826a6f6d5c1.png";